(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire716c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire716c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("exBt4", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $a961361f34d9a272$export$6503ec6e8aabbaf; }, function (v) { return $a961361f34d9a272$export$6503ec6e8aabbaf = v; });
var $a961361f34d9a272$export$6503ec6e8aabbaf;
var $a961361f34d9a272$export$f7ad0328861e2f03;
"use strict";
var $a961361f34d9a272$var$mapping = new Map();
function $a961361f34d9a272$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$a961361f34d9a272$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $a961361f34d9a272$var$resolve(id) {
    var resolved = $a961361f34d9a272$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$a961361f34d9a272$export$6503ec6e8aabbaf = $a961361f34d9a272$var$register;
$a961361f34d9a272$export$f7ad0328861e2f03 = $a961361f34d9a272$var$resolve;

});

parcelRegister("eAada", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $a9dc59450d9b029f$export$bdfd709ae4826697; }, function (v) { return $a9dc59450d9b029f$export$bdfd709ae4826697 = v; });
var $a9dc59450d9b029f$export$bdfd709ae4826697;
var $a9dc59450d9b029f$export$c9e73fbda7da57b6;
var $a9dc59450d9b029f$export$5a759dc7a1cfb72a;
"use strict";
var $a9dc59450d9b029f$var$bundleURL = {};
function $a9dc59450d9b029f$var$getBundleURLCached(id) {
    var value = $a9dc59450d9b029f$var$bundleURL[id];
    if (!value) {
        value = $a9dc59450d9b029f$var$getBundleURL();
        $a9dc59450d9b029f$var$bundleURL[id] = value;
    }
    return value;
}
function $a9dc59450d9b029f$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $a9dc59450d9b029f$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $a9dc59450d9b029f$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $a9dc59450d9b029f$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$a9dc59450d9b029f$export$bdfd709ae4826697 = $a9dc59450d9b029f$var$getBundleURLCached;
$a9dc59450d9b029f$export$c9e73fbda7da57b6 = $a9dc59450d9b029f$var$getBaseURL;
$a9dc59450d9b029f$export$5a759dc7a1cfb72a = $a9dc59450d9b029f$var$getOrigin;

});

var $4994bfb9ac4f9b97$exports = {};


(parcelRequire("exBt4")).register((parcelRequire("eAada")).getBundleURL("c8Lka"), JSON.parse('["c8Lka","index.15976d35.js","gEMXA","alku-logo.a90db96a.png","f3sqm","logo.a6de682e.png","6ecEi","index.eec369d2.css"]'));

})();
//# sourceMappingURL=index.runtime.81b0f139.js.map
